import React from 'react';

import './WelcomePane.scss';
import NotFound from 'Core/Status/NotFound';
import Headline from 'Core/Components/Headline';
import PaneController from 'RLX/Controllers/PaneController';
import { PaneHeader, SectionTitle } from 'Dashboard/Panes/Common';


class WelcomePane extends PaneController {
  constructor (props) {
    super(props);
  }

  renderIndex () {
    const title = <span>Welcome to <b>RLX</b></span>;
    return (
      <div className="Pane WelcomePane">
        {/*<PaneHeader title={title} />*/}
        <img src="/assets/rlx/left-side.png" style={{ height: '40vh', margin: '15vh auto 15vh 0' }} />
        {/*<PaneHeader title={title} />*/}
        {/*
          <SectionTitle>Getting Started</SectionTitle>
          <p>Use the navigation at left to get started.</p>
          <a href="mailto:austin@austinbillings.com">
            <button>Something wrong?</button>
          </a>
        */}
      </div>
    );
  }
};

export default WelcomePane;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Welcome/WelcomePane.jsx